import { IApplicationState } from '../../types/redux';

export function getActiveRatingFilters(state: IApplicationState) {
  return state.filters.ratings.filter(el => el.checked);
}
